import { render } from "./NewPassword.vue?vue&type=template&id=5d2a05db"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__